/**
 * GEOGRAPHY SLICE — Cache di countries (lista flat) e regions (mappa per
 * countryId). Read-only: nessun CRUD, solo lazy fetch popolato dai thunk.
 *
 * Pattern di indicizzazione `regionsByCountry` ispirato a
 * `relationshipSlice.byTargetType`. Pattern di "load-once con condition"
 * preso da `personSourceSlice` ma esteso per chiave (countryId).
 */

import { createSlice } from '@reduxjs/toolkit';
import { fetchCountries, fetchRegionsForCountry } from './geographyThunks';
import type { GeographyState } from './geographyTypes';

const initialState: GeographyState = {
  countries: [],
  countriesStatus: 'idle',
  countriesError: null,
  regionsByCountry: {},
  regionsStatus: {},
  regionsError: {},
};

export const geographySlice = createSlice({
  name: 'geography',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // --- countries ---
      .addCase(fetchCountries.pending, (state) => {
        state.countriesStatus = 'loading';
        state.countriesError = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.countriesStatus = 'succeeded';
        state.countries = action.payload;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.countriesStatus = 'failed';
        state.countriesError = (action.payload as string) ?? null;
      })
      // --- regions per country ---
      .addCase(fetchRegionsForCountry.pending, (state, action) => {
        const countryId = action.meta.arg;
        state.regionsStatus[countryId] = 'loading';
        state.regionsError[countryId] = null;
      })
      .addCase(fetchRegionsForCountry.fulfilled, (state, action) => {
        const countryId = action.meta.arg;
        state.regionsStatus[countryId] = 'succeeded';
        state.regionsByCountry[countryId] = action.payload;
      })
      .addCase(fetchRegionsForCountry.rejected, (state, action) => {
        const countryId = action.meta.arg;
        state.regionsStatus[countryId] = 'failed';
        state.regionsError[countryId] = (action.payload as string) ?? null;
      });
  },
});

export const geographyReducer = geographySlice.reducer;
